<template>
    <div
        v-on-clickaway="away"
        class="subscription-dropdown"
        :class="{ active: isActive, 'is-only-lifetime': 1 === subscriptions.length }"
        @click="handleDropdown"
    >
        <div class="dropdown-select flex">
            <div class="current-plan">
                Fusebox {{ currentSubscription.name }}
            </div>
            <div
                v-if="1 < subscriptions.length"
                class="dropdown-trigger"
            >
                <i
                    class="fal"
                    :class="{ 'fa-chevron-up': isActive, 'fa-chevron-down': !isActive }"
                />
            </div>
            <div
                class="dropdown-content"
                :class="{ active: isActive }"
            >
                <a
                    v-for="subscription in subscriptions"
                    :key="subscription.id"
                    :class="{current: currentSubscription && subscription.id === currentSubscription.id}"
                    href="#"
                    @click.prevent="selectOption( subscription )"
                >
                    Fusebox {{ subscription.name }}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import subscritionsList from '@/mixins/subscriptionsList';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [
        subscritionsList,
        clickaway,
    ],

    data: () => ({
        isActive: false,
    }),

    methods: {
        /**
         * Handles close dropdown
         */
        away() {
            if (! this.isActive) return;

            this.isActive = ! this.isActive;
        },

        /**
         * Handles select option
         *
         * @param {object} subscription Subscription.
         */
        selectOption(subscription) {
            this.away();
            this.handleClick(subscription);
            this.handleDropdown();
        },

        /**
         * Handles dropdown action
         */
        handleDropdown() {
            if (1 === this.subscriptions.length) return;

            this.isActive = ! this.isActive;
        },
    },

};
</script>
